import React from "react";
import { Modal } from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import Text from "../text";
import { Title } from "../title";
import "./style.scss";

export const Popup = ({
  title,
  description,
  children,
  buttons,
  show,
  onClose,
  ...props
}) => {
  return (
    <>
      <ToastContainer />
      <Modal
        className={`ldsrf-popup ${!buttons ? "no-button" : ""}`}
        show={show}
        onHide={() => onClose()}
      >
        <Modal.Header>
          <Title size="regular">{title ? title : ""}</Title>
          <button onClick={() => onClose()} className="close-button">
            <i class="fad fa-times"></i>
          </button>
        </Modal.Header>
        <Modal.Body>
          {description ? <Text align="center">{description}</Text> : null}
          {children}
        </Modal.Body>
        <Modal.Footer>
          {buttons &&
            buttons.length > 0 &&
            buttons.map((button) => {
              return button;
            })}
        </Modal.Footer>
      </Modal>
    </>
  );
};
